import { Injectable, EventEmitter} from '@angular/core';

export interface DialogOpenEventArgs {
	title: string;
	content: string;
}

export interface PopupButton {
	text: string;
	color: string;
	action: any;
}

export interface PopupOpenEventArgs {
	text: string;
	buttons?: PopupButton[];
	x?: number;
	y?: number;
	tooltip?: boolean;
}

@Injectable()
export class DialogService {

	/**
	 * Open dialog event
	 */
	public openDialogEvent: EventEmitter<DialogOpenEventArgs | null> = new EventEmitter<DialogOpenEventArgs | null>();

	/**
	 * Open popup event
	 */
	 public openPopupEvent: EventEmitter<PopupOpenEventArgs | null> = new EventEmitter<PopupOpenEventArgs | null>();

	/**
	 * Constructor
	 */
	constructor() {
	}

	/**
	 * Open dialog
	 */
	public openDialog(title: string, content: string): void {
		this.openDialogEvent.emit({title, content});
	}

	/**
	 * Close dialog
	 */
	public closeDialog(): void {
		this.openDialogEvent.emit(null);
	}

	/**
	 * Open popup
	 */
	 public openPopup(args: PopupOpenEventArgs): void {
		this.openPopupEvent.emit(args);
	}

	/**
	 * Close popup
	 */
	public closePopup(): void {
		this.openPopupEvent.emit(null);
	}
}
